import { useQuery } from "react-query";

import axios, { AxiosError } from "axios";
import { DATA_SVC_RS_ADDRESS } from "constants/app.constants";

const API_URL = `${DATA_SVC_RS_ADDRESS}/api/v1/midstream/network-fractions`;

export const GetNetworkFractionKey = "network-fraction";

export interface NetworkFraction {
  wellId: string;
  gasPct: number;
  wellName: string;
  nodeDistance: number;
  gasMcf: number;
  productionMonth: number;
  operator: string;
  resourcePlay: string;
  destinationFacility?: string;
}

const fetchNetworkFraction = async (facilityId?: string) => {
  if (!facilityId) {
    return Promise.resolve([]);
  }
  const response = await axios.get<NetworkFraction[]>(`${API_URL}/${facilityId}`);
  const data = response?.data;
  if (!Array.isArray(data)) {
    return [];
  }
  return response?.data ?? [];
};

const useGetFacilityNetworkFraction = (facilityId: string) => {
  return useQuery<NetworkFraction[], AxiosError>(
    [GetNetworkFractionKey, facilityId],
    () => fetchNetworkFraction(facilityId),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes - cache data for 5 minutes
      cacheTime: 10 * 60 * 1000 // 10 minutes - keep in cache for 10 minutes
    }
  );
};

export default useGetFacilityNetworkFraction;
